import { Component, OnInit } from '@angular/core';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';
import * as FileSaver from 'file-saver-es';
import { formatDate } from '@angular/common';
import { SafetyDashboardService } from 'src/app/services/safety-dashboard.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { ConstantsService } from 'src/app/services/constants.service';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-reports-safety-dashboard',
    templateUrl: './reports-safety-dashboard.component.html',
    styleUrls: ['./reports-safety-dashboard.component.scss'],
    standalone: false // NOSONAR
})
export class ReportsSafetyDashboardComponent implements OnInit {

  faChevronRight=faChevronRight;
  curDate=formatDate(new Date(),'yyyyMMdd','en');
  errorMessage: any;
  successMessage: any;
  isAccessible=true;
  
  constructor( private readonly safetydashboardService :SafetyDashboardService,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
    public constants: Constants,
     private readonly aetStateService : AetStateService, 
    private readonly router: Router) { }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    // this.checkRoles();
    this.ngxUiLoaderService.stop(CommonConstant.loader);
  }
  // async checkRoles() {
  //   await this.aetStateService.getRoles();
  //   const roles = this.aetStateService.getroleState();
  //   const userRoles = JSON?.parse(roles);
  //   if(userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter) || 
  //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) 
  //   || userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) || userRoles.includes(this.constants.LIOS_UAC_AET_LP) 
  //   || userRoles.includes(this.constants.LIOS_UAC_General_User))){
  //     this.isAccessible = true;
     
  //   }
  //   else{
  //     this.router.navigate([`/home`]);
  //   }
  //   // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
  //   //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
  //   //   // this.isAccessible = true;
  //   // } else {
  //   //   this.router.navigate([`/home`]);
  //   // }
  // }
  downloads(){ 
    this.successMessage=null;
    this.errorMessage=null;
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.safetydashboardService.getreport(userInfo)
    .subscribe({
      next:(response)=>{
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        const filename="AET-SafetyDashboard-"+this.curDate
        const data: Blob = new Blob([(<any>response)?.body], { type: 'application/vnd.ms-excel' });
        FileSaver.saveAs(data, filename); 
      },
      error: ()=>{
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.downloadError;
        
      }
    })
  }



}
